module.exports = __webpack_public_path__ + "static/ro-workshops-1-8fe7c6cd0332c65e4406aa7891a56e1e.jpg";